// these colors are the same as what is on backend
// you can see them all in athena at
// app/models/distinct_colors.rb
// sorted differently

export default [
  '#ff00ff',
  '#ff1593',
  '#da70d6',
  '#d8a8c3',
  '#bebeb9',
  '#c3e0c3',
  '#a7cdd0',
  '#bad789',
  '#fef4a9',
  '#d6572b',
  '#ff4500',
  '#ff8c00',
  '#daa521',
  '#eda234',
  '#ffd701',
  '#adff2e',
  '#7cfb02',
  '#33cd32',
  '#238b21',
  '#20542d',
  '#2a295a',
  '#5d3c35',
  '#6f1d2f',
  '#a4262a',
  '#dc143c',
  '#b71c6f',
  '#813c85',
  '#6f6f6c',
  '#5c4287',
  '#8a2be2',
  '#7b68ee',
  '#9c85b1',
  '#b2679c',
  '#de639a',
  '#d77d8b',
  '#e88364',
  '#c09350',
  '#958f38',
  '#82bc4c',
  '#57a545',
  '#3cb371',
  '#4cb592',
  '#22b2aa',
  '#429bc9',
  '#4681b4',
  '#6382a4',
  '#415b99',
  '#138d7d',
  '#178183',
  '#00fa99',
  '#00ffff',
  '#00ced1',
  '#05bfff',
  '#1f90ff',
  '#0a00ff',
  '#0a0b09',
]
